module.exports = __webpack_public_path__ + "static/media/hapanel_final.d4af3fac.jpg";